// extracted by mini-css-extract-plugin
export default {"root":"BreadLayout_root__bvkt2","main":"BreadLayout_main__DnkDf","body":"BreadLayout_body__Qf0Fy"};